var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUnregistered({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.75 36C42.975 36 36 42.975 36 51.75C36 60.525 42.975 67.5 51.75 67.5C60.525 67.5 67.5 60.525 67.5 51.75C67.5 42.975 60.525 36 51.75 36ZM51.75 63V40.5C58.05 40.5 63 45.45 63 51.75C63 58.05 58.05 63 51.75 63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 36H18V40.5H31.5V36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22.5H18V27H45V22.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 9C58.5 6.525 56.475 4.5 54 4.5H9C6.525 4.5 4.5 6.525 4.5 9V38.25C4.5 47.475 9.45 55.8 17.55 60.075L29.25 66.375V61.2L19.8 56.025C13.05 52.65 9 45.675 9 38.25V9H54V29.25H58.5V9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnregistered);
export default __webpack_public_path__ + "static/media/ic-unregistered.daea741228e565198b8680560d4af1af.svg";
export { ForwardRef as ReactComponent };